export const reviews = [
    {
        id: 1,
        name: "Ramu",
        title: "Saimoo Insurance,Trivandrum",
        //avatar: "https://i.pravatar.cc/150?u=peter",
        text: "Policytrackr feels like it’s made for insurance agents, not a generic software. It fits our daily work perfectly."
    },
    {
        id: 2,
        name: "Mani",
        title: "Trivandrum",
        //avatar: "https://i.pravatar.cc/150?u=sarah",
        text: "Earlier my staff had to enter policy details manually. Now we upload the PDF and Policytrackr handles tracking and reminders on its own. Very easy for the whole office!."
    },
    {
        id: 3,
        name: "Kannan",
        title: "Trivandrum",
        //avatar: "https://i.pravatar.cc/150?u=james",
        text: "We used Excel and WhatsApp for years. Policytrackr finally gave us one place to manage policies and renewals without confusion."
    }
];
